<template>
<modal name="modal-confirm-split-order" :width="350" :height="'auto'" scrollable>
    <div class="px-6 py-8">
    	<div class="right-0 top-0 p-2 absolute">
            <button @click="$modal.hide('modal-confirm-split-order')" class="text-gray-600 hover:base-color">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
        </div>
    	<div class="flex flex-col justify-center gap-2">
    		<div class="flex justify-center mb-2">
    			<div class="relative">
	    			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-16 h-16 flex-shrink-0"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"></path></svg>
	    			<div class="inline-flex absolute -top-2 -right-2 justify-center items-center w-8 h-8 text-sm font-bold text-white bg-red-500 rounded-full border-2 border-white dark:border-gray-900">1</div>
    			</div>
    		</div>
        	<div class="text-center text-base">
        		{{ this.$root.getKeyWord('popup_confirm_order') }}
        	</div>
        	<div class="flex justify-between gap-4 mt-4">
        		<button class="h-8 px-2 w-full text-center rounded-full border border-black text-black text-xs" @click="cleanCart">{{ this.$root.getKeyWord('clean_cart') }}</button>
        		<button class="bg-hotel h-8 px-2 w-full text-center rounded-full text-white text-xs" @click="openCart">{{ this.$root.getKeyWord('complete_order') }}</button>
        	</div>
        </div>
    </div>   
</modal>
</template>

<script>
import { eventBus } from '../../main';
export default {
	methods: {
		cleanCart() {
			this.$root.cleanCart();
			this.$modal.hide('modal-confirm-split-order');
		},

		openCart() {
			this.$modal.hide('modal-confirm-split-order');
			eventBus.$emit('cart');
		},
	}
}
</script>